export const NAV_LINKS = [
  { label: "How It Works", href: "#path" },
  { label: "Who It's For", href: "#who" },
  { label: "Project Examples", href: "#projects" },
  { label: "About the Instructor", href: "#instructor" },
  { label: "FAQ", href: "#faq" },
];

export const TRUST = [
  { icon: "user", text: "Taught LLM Foundations, Prompt Engineering and Agentic AI" },
  { icon: "shield", text: "9+ years in quality engineering" },
  { icon: "code", text: "600+ APIs validated" },
  { icon: "users", text: "This is ArtOfResume's own, independently designed cohort." },
];

export const STEPS = [
  { title: "Scope", text: "Define a bounded, domain-relevant problem", icon: "crosshair" },
  { title: "Baseline", text: "Establish a simple baseline you can measure", icon: "ruler" },
  { title: "Build", text: "Implement with the right tools and data for your case", icon: "code" },
  { title: "Test", text: "Evaluate quality, robustness, and trade-offs", icon: "clipboard" },
  { title: "Explain", text: "Document choices and explain results clearly", icon: "message" },
];

export const TRACKS = [
  { key: "foundation", title: "FOUNDATION", text: "For those starting or rebuilding AI fundamentals. Build confidence with a well-scoped first project.", icon: "cap", tone: "blue" },
  { key: "build", title: "BUILD", text: "For those who can code and want hands-on practice with data, models, and evaluation.", icon: "wrench", tone: "teal" },
  { key: "architecture", title: "ARCHITECTURE", text: "For those designing systems and want to architect reliable, scalable AI solutions.", icon: "boxes", tone: "violet" },
];

export const PROJECTS = [
  { key: "api", title: "QA / API Reliability Assistant", bullets: ["Validate requirements", "Detect anomalies", "Generate test suggestions"] },
  { key: "doc", title: "Document Workflow Automator", bullets: ["Extract and classify documents", "Route with rules & RAG", "Summarize and audit actions"] },
  { key: "retail", title: "Retail Demand & Insight Engine", bullets: ["Forecast product demand", "Detect trends & risks", "Deliver actionable insights"] },
];

export const FOR = [
  "Working technology professionals",
  "Limited time but want practical, hands-on learning",
  "Want domain-relevant projects they can explain",
  "Prefer guidance with real-world context and trade-offs",
];

export const NOT_FOR = [
  "Looking for certifications without practical work",
  "Wanting code-only labs without context",
  "Expecting job placement or referrals",
  "Prefer fully self-paced without structure",
];

export const FAQ = [
  { q: "Is this a job or salary guarantee?", a: "No. The diagnostic gives an initial direction, not a hiring prediction. ArtOfResume does not guarantee jobs, salary increases, interviews, or production readiness." },
  { q: "Do I need to buy every course?", a: "No. This is a learning pathway, not a compulsory package. The diagnostic recommends an entry point based on your goals, prior experience, and available time. An experienced learner may be ready for a later course without taking every earlier one, subject to the prerequisites." },
  { q: "How is my starting route chosen?", a: "Your five answers route you to Foundation, Build, or Architecture & Evidence. The route is provisional and can be corrected after discussion. It is not an independent technical assessment." },
  { q: "What should I avoid sharing?", a: "Do not submit confidential employer, client, customer, or personal data. Describe your work problem in general terms." },
  { q: "What happens after the diagnostic?", a: "You receive your provisional route and a PDF guide, Your AI Project Starting Point. If your project and goals fit the ArtOfResume pilot, you can request a Project Fit Call to discuss scope, time, and next steps." },
];

export const AREAS = [
  "QA, software testing, or test automation",
  "Software development or APIs",
  "Data, analytics, or data engineering",
  "Cloud, DevOps, or platform engineering",
  "Architecture or technical leadership",
  "Operations, business analysis, or process improvement",
  "Other",
];
export const INDUSTRIES = ["Banking / financial services", "Retail / e-commerce", "Healthcare", "Logistics / supply chain", "Enterprise software", "Other"];
export const GOALS = [
  "Improve a task or workflow in my current role",
  "Build a practical AI feature or project",
  "Move toward an AI-related role",
  "Evaluate or design where AI fits in a business solution",
  "Improve how I test, review, or govern AI systems",
  "I am still deciding",
];
export const EXPERIENCE = [
  "I have not tried an AI project yet",
  "I have used AI assistants or prompts, but have not built a project",
  "I have followed a tutorial or built a small personal project",
  "I have built a project or prototype connected to a real use case",
  "I have implemented or supported an AI workflow in a workplace setting",
  "I have an existing system or design I want to evaluate or improve",
];
export const BLOCKERS = [
  "I need the foundations explained clearly",
  "I am unsure which AI topic, framework, or project to choose",
  "I need more time and a smaller practice plan",
  "I need help turning an idea into a working implementation",
  "I need feedback on testing, evaluation, reliability, or failure cases",
  "I need architecture or trade-off guidance",
  "I can build something, but need to explain my technical decisions and limitations",
  "Other",
];
export const HOURS = ["Under 2 hours", "2-4 hours", "5-7 hours", "8 or more hours"];

export const QUESTIONS = [
  { key: "area", title: "Which description best matches the work you do today?", hint: "Select one primary area and, if helpful, one industry.", options: AREAS },
  { key: "goal", title: "What would you most like AI to help you do next?", hint: "Choose one.", options: GOALS },
  { key: "experience", title: "What is the most advanced AI-related work you have completed yourself?", hint: "Choose the closest answer. This records self-reported experience; it does not verify skill or production readiness.", options: EXPERIENCE },
  { key: "blocker", title: "What is the main thing slowing your progress right now?", hint: "Choose one.", options: BLOCKERS },
  { key: "hours", title: "What time can you realistically protect for practice each week?", hint: "Choose one.", options: HOURS },
];

export const QUICK_FIELDS = [
  { key: "area", label: "Current role", icon: "user", options: AREAS },
  { key: "goal", label: "AI goal", icon: "target", options: GOALS },
  { key: "experience", label: "What have you tried?", icon: "search", options: EXPERIENCE },
  { key: "blocker", label: "Biggest blocker right now?", icon: "message", options: BLOCKERS },
  { key: "hours", label: "How many hours can you commit weekly?", icon: "clock", options: HOURS },
];
